import { EventEmitter, OnInit, ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material';
import { merge, fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { RecentSearchesService } from '../../../search/shared/recent-searches.service';
import { MenuService } from '../../header/menu/menu.service';
import { AuthService } from '../../../core/auth/auth.service';
import { LanguageService } from '../../../core/language/language.service';
import { ItauUserIdleService } from '@app/core/security/itau-user-idle.service';
import { SessionService } from '@app/core/session/session.service';
import { SearchService } from '@app/search/shared/search.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { Router } from '@angular/router';
import { detailFromBreadcrumb, normalizePath, normalizePathFromBreadcrumb } from '@app/shared/utils';
var SearchBarComponent = /** @class */ (function () {
    function SearchBarComponent(fb, recentSearchesService, menuService, authService, _window, languageService, itauUserIdleService, sessionService, searchService, _sdkAnalyticsService, router) {
        this.fb = fb;
        this.recentSearchesService = recentSearchesService;
        this.menuService = menuService;
        this.authService = authService;
        this._window = _window;
        this.languageService = languageService;
        this.itauUserIdleService = itauUserIdleService;
        this.sessionService = sessionService;
        this.searchService = searchService;
        this._sdkAnalyticsService = _sdkAnalyticsService;
        this.router = router;
        this.isFocused = new EventEmitter();
        this.submitted = new EventEmitter();
        this.flgShow = true;
        this.isSearch = false;
    }
    SearchBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe(function (user) {
            _this.authUser = user;
        });
        this.searchForm = this.fb.group({
            searchTerm: null
        });
        this.subMenus = this.selectAutocompleteList([]);
        this.watchSearchQueryChanges();
        this.menuService.getMenu().subscribe(function (menu) {
            _this.menus = menu;
            if (menu)
                _this.getRecentSearches();
        });
    };
    SearchBarComponent.prototype.onSubmit = function (f) {
        f.value.searchTerm = f.value.searchTerm !== null ? f.value.searchTerm.trim() : '';
        if (f.value.searchTerm == '' || !this.flgShow)
            return;
        this.autocomplete.closePanel();
        this.submitted.emit(true);
        this.menuService.searchFor(f.value.searchTerm);
        this.searchService.setSearchbarTabindex(9);
    };
    SearchBarComponent.prototype.watchSearchQueryChanges = function () {
        var _this = this;
        this.searchFormChange$ = this.searchForm.get('searchTerm').valueChanges
            .pipe(debounceTime(100), map(function (value) { return _this.filterMenu(value); }));
        this.searchFormChange$.subscribe(function (filteredList) {
            _this.subMenus = _this.selectAutocompleteList(filteredList);
        });
    };
    SearchBarComponent.prototype.onOpenOptions = function () {
        var items = document.getElementsByClassName('mat-form-field-outline-end');
        while (items.length > 0) {
            items[0].className = 'mat-form-field-outline-end-focused-custom';
        }
        this.isFocused.emit(true);
    };
    SearchBarComponent.prototype.onCloseOptions = function () {
        var items = document.getElementsByClassName('mat-form-field-outline-end-focused-custom');
        while (items.length > 0) {
            items[0].className = 'mat-form-field-outline-end';
        }
        this.isFocused.emit(false);
    };
    SearchBarComponent.prototype.selectAutocompleteList = function (filteredSearchResults) {
        var inputElement = this.headerSearchBarElement.nativeElement;
        if (inputElement.value.trim() === '') {
            return this.recentSearchesList;
        }
        return filteredSearchResults;
    };
    SearchBarComponent.prototype.clearSearchField = function () {
        this.searchForm.get('searchTerm').setValue('');
    };
    SearchBarComponent.prototype.getRecentSearches = function () {
        var _this = this;
        this.recentSearchesService.getUpdatedRecentSearches().subscribe(function (search) {
            _this.recentSearchesList = search;
            if (!_this.subMenus) {
                _this.subMenus = _this.recentSearchesList;
            }
        });
    };
    SearchBarComponent.prototype.filterMenu = function (value) {
        var _this = this;
        if (!value) {
            this.isSearch = false;
            this.flgShow = true;
            return null;
        }
        var filterValue = value.toLowerCase();
        if (this.menus) {
            this.menuService.getPath();
            this.isSearch = true;
            this.flgShow = true;
            this.subMenus = [];
            var resultSubMenu = this.menuService.filterMenu(filterValue);
            if (resultSubMenu) {
                resultSubMenu.slice(0, 5).forEach(function (x) {
                    _this.subMenus.push(x);
                });
            }
            this.flgShow = this.subMenus.length > 0;
        }
        return this.subMenus;
    };
    Object.defineProperty(SearchBarComponent.prototype, "searchTermLength", {
        get: function () {
            var inputElement = this.headerSearchBarElement.nativeElement;
            return inputElement.value.trim().length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchBarComponent.prototype, "searchTermIsLengthy", {
        get: function () {
            if (!this.searchForm.get('searchTerm').value)
                return false;
            return this.searchForm.get('searchTerm').value.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    SearchBarComponent.prototype.redirectPage = function () {
        var _this = this;
        var inputElement = this.headerSearchBarElement.nativeElement;
        var pageName = inputElement.value.toLowerCase();
        var sub = this.subMenus.filter(function (sm) { return _this.languageService.translate(sm.translationKey).includes(pageName); })[0];
        if (sub.path && this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: detailFromBreadcrumb(sub.path, 'resultado-busca:')
            });
        }
        if (sub.tipoMenu != 5) {
            this.itauUserIdleService.stopWatching();
            this.sessionService.updateSession().subscribe(function () { });
            var sUrl = this.authUser.serverEstatisticas + '?xyz=0';
            try {
                var userType = this.authUser.tipo == 1 ? "A" : "C";
                sUrl += this.getQueryString(this.authUser.token, this.authUser.idSessao, this.authUser.idConexao, this.authUser.gestor, this.authUser.name, userType);
                sUrl += this.getQueryStringFunction(sub.id);
                var windowOK4 = this._window.open(sUrl, name, 'directories=no,resizable=1,location=no,scrollbars=yes,height=560,width=790,left=5,top=5');
                this.itauUserIdleService.setCustomActivityEvents(merge(fromEvent(window, 'mousemove'), fromEvent(window, 'resize'), fromEvent(document, 'keydown'), fromEvent(document, 'touchstart'), fromEvent(document, 'touchend'), fromEvent(windowOK4, 'mousemove'), fromEvent(windowOK4, 'resize')));
                this.itauUserIdleService.startWatching();
                if (sub.path) {
                    this._sdkAnalyticsService.trackEvent('screen_view', {
                        custom_path: normalizePathFromBreadcrumb(sub.path, { prefix: '/iss/lg/' }),
                        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                        detail: detailFromBreadcrumb(sub.path, 'resultado-busca:')
                    });
                }
            }
            catch (ex) {
                throw ex;
            }
        }
        else {
            this.openModalContext(sub.url);
        }
    };
    SearchBarComponent.prototype.openModalContext = function (url) {
        this.menuService.openContext(url);
    };
    SearchBarComponent.prototype.getQueryStringFunction = function (codFunction) {
        try {
            return '&iDFuncao=' + (-1 * codFunction);
        }
        catch (ex) {
            throw ex;
        }
    };
    SearchBarComponent.prototype.getQueryString = function (token, idConnection, idSession, sGestor, nameUser, userType) {
        try {
            return '&sessao=' + token +
                '&id=' + idConnection +
                '&idsessao=' + idSession +
                '&gestor=' + sGestor +
                '&nomeUsu=' + nameUser +
                '&tipousu=' + userType;
        }
        catch (ex) {
            throw ex;
        }
    };
    return SearchBarComponent;
}());
export { SearchBarComponent };
